import { Col, Container, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import eye from '../../../../../assets/images/icons/eye.svg';
import OpacityAnimation from '../../../../../components/OpacityAnimation';
import useGetGeneralAppData from '../../../../../hooks/useGetGeneralAppData';
import dateJsToReadableDate from '../../../../../utils/dateJsToReadableDate';
import floatToCurrency from '../../../../../utils/floatToCurrency';
import hideCpf from '../../../../../utils/hideCpf';
import { DadosConsulum } from '../../types';
import {
  Card,
} from './styles';

interface ListInterface {
  filteredConsults: DadosConsulum[];
  isSelectingConsults: boolean;
  selectedConsults: number[];
  handleConsultSelection: (cst: number) => void;
  selectedType: 'base' | 'preAdm';
}

export default function ConsultsList({
  filteredConsults,
  isSelectingConsults,
  selectedConsults,
  handleConsultSelection,
  selectedType,
}: ListInterface) {
  const smallTagRenderByStatusRot: { [key: string]: JSX.Element } = {
    Implantado: <small className='green'>Implantado</small>,
    Otimizado: <small className='green'>Otimizado</small>,
    'Não Otimizado': <small className='orange'>Não Otimizado</small>,
    'Acima do Teto': <small className='orange'>Acima do Teto</small>,
    'Acima do Valor': <small className='orange'>Acima do Valor</small>,
    'Sem Resultado': <small className='red'>Sem Resultado</small>,
    'Fora de Abrangência': <small className='red'>Fora de Abrangência</small>,
    'Caminhada a pé': <small>Caminhada a pé</small>,
    'Em processamento': <small>Em processamento</small>,
    'Sem Status': <small className='gray'>Sem Status</small>,
  };

  const smallTagRenderByStatusConsult: { [key: string]: JSX.Element } = {
    Roteirizado: <small>Roteirizado</small>,
    Implantado: <small className='green'>Implantado</small>,
  };

  const { companyCode } = useGetGeneralAppData();

  return (
    <Container>
      <Row xs={1} md={2} lg={2}>
        {filteredConsults?.map((cst) => (
          <Col key={`${cst.codConsulta}|${cst.dataRot}`}>
            <OpacityAnimation delay={0.1}>
              <Card isSelectingConsults={isSelectingConsults} selected={selectedConsults.includes(cst.codConsulta)} onClick={() => handleConsultSelection(cst.codConsulta)}>
                <div className="info">
                  <div className="card-title">
                    <strong>{cst.codConsulta} - {cst.nome}</strong>
                    {smallTagRenderByStatusRot[cst.statusRot]}
                  </div>
                  <span>
                    {cst.tipoRoteirizacao.toUpperCase()}
                  </span>
                  <span>
                    Gerada em {dateJsToReadableDate(cst.dataCad)}
                  </span>
                  <span>
                    Última roteirização em {dateJsToReadableDate(cst.dataRot)}
                  </span>
                  <span>
                    CPF: {hideCpf(cst.cpf) || 'Não informado'}
                  </span>
                  <span>
                    Matrícula: {cst.matricula || 'Não informada'}
                  </span>
                  {selectedType === 'base' && (
                    <>
                      <span>
                      Valor Antes:
                        {' '}
                        {cst.valorAntes ? floatToCurrency(cst.valorAntes) : 'Não informado'}
                      </span>
                      <span>
                      Valor Depois:
                        {' '}
                        {cst.valorDepois ? floatToCurrency(cst.valorDepois) : 'Não calculado'}
                      </span>
                      <span>
                      Economia:
                        {' '}
                        {cst.economia ? floatToCurrency(cst.economia) : 'Sem Economia'}
                      </span>
                    </>
                  )}
                  {/* <span>
                    Tipo:
                    {' '}
                    {cst.tipoRoteirizacao || 'Sem Tipo'}
                  </span> */}
                  <span>
                    {smallTagRenderByStatusConsult[cst.statusConsulta]}
                  </span>
                </div>
                {!isSelectingConsults && (
                  <div className="actions">
                    <Link to={`/consults/result/${cst.codConsulta}?codEmpresa=${companyCode}&activeSidebar=SearchConsults&returnLink=${encodeURIComponent('/consults/search')}${cst.tipoRoteirizacao.toLowerCase().trim().startsWith('multi') ? '&mr' : ''}`}>
                      <img src={eye} alt="" title='Visualizar Resultado' />
                    </Link>
                  </div>
                )}
              </Card>
            </OpacityAnimation>
          </Col>
        ))}
      </Row>
    </Container>
  );
}
